import axios from "../../config/axiosConfig";
import {
  PURCHASE_OUTSTANDING_REPORT_REQUEST,
  PURCHASE_OUTSTANDING_REPORT_SUCCESS,
  PURCHASE_OUTSTANDING_REPORT_FAILURE
} from "../types/purchase-outstanding-report-types";

export const getPurchaseOutstandingRegisterReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_OUTSTANDING_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      console.log('params', params);
      
      const requestParams = { ...defaultParams, ...params };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/outstanding-report/getPurchaseReport?${queryString}`;

      console.log('Complete API Request URL: ', fullUrl);

      return axios.get('/outstanding-report/getPurchaseReport', {
        params: requestParams,
      }).then((response) => {
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: PURCHASE_OUTSTANDING_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Purchase Outstanding Report:", error);
        dispatch({ type: PURCHASE_OUTSTANDING_REPORT_FAILURE, error: error.message });          
      });
    } catch (error) {
      console.error("Error fetching Purchase Outstanding Report:", error);
      dispatch({ type: PURCHASE_OUTSTANDING_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearPurchaseOutstandingRegisterReport = () => {
  return async (dispatch) => {
    dispatch({ type: PURCHASE_OUTSTANDING_REPORT_SUCCESS, payload: {} });
  }
}
